import React from "react";
import "../IB/IB.css";
import { Link } from "react-router-dom";
import {
  FaUtensils,
  FaUmbrellaBeach,
  FaPhoneAlt,
  FaPlane,
  FaBus,
  FaPassport,
} from "react-icons/fa";

const tripData = [
  {
    id: 1,
    title: "Caribbean",
    slug: "caribbean",
    price: "£799pp",
    description:
      "Sun-soaked islands, crystal-clear seas & relaxed tropical escapes",
    images: [
      "/caribbean1.webp",
      "/caribbean2.webp",
      "/caribbean3.webp",
      "/caribbean4.webp",
    ],
  },

  {
    id: 2,
    title: "Canada",
    slug: "canada",
    price: "£749pp",
    description: "Breathtaking nature, cities & scenic adventures",
    images: ["/ca.webp", "/ca2.webp", "/ca3.webp", "/ca4.webp"],
  },
  {
    id: 3,
    title: "USA",
    slug: "usa",
    price: "£699pp",
    description: "From iconic cities to unforgettable road trips",
    images: ["/usa.webp", "/usa1.webp", "/usa2.webp", "/usa3.webp"],
  },
  {
    id: 4,
    title: "Australia & New Zealand",
    slug: "a&n",
    price: "£1,199pp",
    description: "Exotic wildlife, beaches & world-class experiences",
    images: ["/au1.webp", "/au2.webp", "/au3.webp", "/au4.webp"],
  },
];

const IB = () => {
  return (
    <section className="ib-section-ib">
      <div className="ib-header-ib">
        <h1>Unbeatable Fares. Expertly Crafted Journeys.</h1>
        <p className="ib-subtitle-ib">
          Specializing in Worldwide Long-Haul Travel with Exclusive 'Phone-Only'
          Rates (save Upto GBP100) Call Now &#9742; ( All Bookings are 100% ATOL
          Protected)
        </p>
      </div>

      <div className="trip-wrapper-ib">
        {tripData.map((trip) => (
          <div className="trip-card-ib" key={trip.id}>
            {/* IMAGE */}
            <div className="trip-image-box-ib">
              {/*--
              <div className="price-tag-ib">{trip.price}</div>
              -*/}

              {/* DESKTOP */}
              <div className="image-composition-ib">
                <div className="image-main-ib">
                  <img src={trip.images[0]} alt={trip.title} />
                </div>

                <div className="image-side-ib">
                  {/* Only show first 2 images from slice(1) */}
                  {trip.images.slice(1, 3).map((img, i) => (
                    <img src={img} alt="" key={i} />
                  ))}
                </div>
              </div>

              {/* MOBILE */}
              <div className="image-stack-ib">
                {trip.images.map((img, i) => (
                  <div className="stack-slide-ib" key={i}>
                    <img src={img} alt="" />
                  </div>
                ))}
                <span className="swipe-indicator-ib">➜</span>
              </div>
            </div>

            {/* CONTENT */}
            <div className="trip-content-ib">
              <h3>{trip.title}</h3>
              <p className="trip-desc-ib">{trip.description}</p>

              <div className="trip-features-ib">
                <span>
                  <FaPlane /> Flights
                </span>
                <span>
                  <FaUtensils /> Meals
                </span>
                <span>
                  <FaUmbrellaBeach /> Sightseeing
                </span>
                <span>
                  <FaBus /> Transfers
                </span>
                <span>
                  <FaPassport /> Visa
                </span>
              </div>

              <div className="trip-actions-ib">
                <Link to={`/flight/${trip.slug}`} className="trip-btn-ib">
                  Book Now
                </Link>

                <a href="tel:02033557350  " className="trip-btn-ib">
                  <FaPhoneAlt /> Call Now
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IB;
